import { createSelector } from 'reselect';
import { isAuthenticatedAsOmni } from '../../modules/account/selectors';

const formatFields = bet => bet.merge({
  betStakePerLine: `£${bet.betStakePerLine}`,
  betStake: `£${bet.betStake}`,
  betPayoutFormatted: `£${bet.betPayoutFormatted}`
});

export const getToBePaidOutIds = state => state.getIn(['settledBets', 'toBePaidOutIds']);
export const getEverythingElseIds = state => state.getIn(['settledBets', 'everythingElseIds']);
export const getMoreChunks = state => state.getIn(['settledBets', 'moreChunks']);
export const getNextSlip = state => state.getIn(['settledBets', 'nextSlip']);
const getSelections = state => state.getIn(['settledBets', 'entities', 'selections']);

export const hasNextSlip = createSelector(
  getNextSlip,
  nextSlip => !!nextSlip
);

const getBet = (state, { betId }) => state.getIn(['settledBets', 'entities', 'bets', betId]);

export const getSelection = (state, { selectionUniqueId }) => (
  state.getIn(['settledBets', 'entities', 'selections', selectionUniqueId])
);

export const makeGetFormattedBet = () => createSelector(
  getBet,
  bet => formatFields(bet)
);

export const getSingleSelectionLabel = createSelector(
  getBet,
  getSelections,
  (bet, selections) => {
    if (bet.betType === 'Single') {
      const firstSelectionId = bet.get('selections').first();
      return selections.getIn([firstSelectionId, 'selectionLabel']);
    }
    return null;
  }
);

export const makeAllowTransferAttempt = () => createSelector(
  isAuthenticatedAsOmni,
  getBet,
  (authenticatedAsOmni, bet) => (
    authenticatedAsOmni
    && bet.fundingType !== 'PLUS'
    && bet.betPayoutValue > 0
    && bet.slipStatus !== 'paid-out'
    && bet.slipStatus !== 'cancelled'
  )
);

export const hasToBePaidOutBets = createSelector(
  getToBePaidOutIds,
  bets => !bets.isEmpty()
);

export const hasEverythingElseBets = createSelector(
  getEverythingElseIds,
  bets => !bets.isEmpty()
);

export const isViewLoading = state => state.getIn(['settledBets', 'viewIsLoading']);
export const isLoadingMoreChunks = state => state.getIn(['settledBets', 'loadingMoreChunks']);
export const isLoadingMoreSlips = state => state.getIn(['settledBets', 'loadingMoreSlips']);
export const getSinceDate = state => state.getIn(['settledBets', 'sinceDate']);
